import type { Language } from "../types";

const es: Record<string, string> = {
  "All": "Todos",
  "Rainforest": "Selva tropical",
  "Ocean": "Océano",
  "Savanna": "Sabana",
  "Arctic": "Ártico",
  "Desert": "Desierto",
  "Forest": "Bosque",
  "Wetlands": "Humedales",
  "Mountains": "Montañas",
  "Mammal": "Mamífero",
  "Bird": "Ave",
  "Amphibian": "Anfibio",
  "Mollusk": "Molusco",
  "Reptile": "Reptil",
  "Fish": "Pez",
  "Worldwide oceans": "Océanos de todo el mundo",
  "Warm oceans": "Océanos cálidos",
  "Tropical oceans": "Océanos tropicales",
  "Central and South America": "Centro y Sudamérica",
  "North Pacific": "Pacífico Norte",
  "Africa": "África",
  "Southern Africa": "África austral",
  "Arctic Ocean": "Océano Ártico",
  "Arctic tundra": "Tundra ártica",
  "Antarctica": "Antártida",
  "Arctic seas": "Mares árticos",
  "Sahara Desert": "Desierto del Sahara",
  "Africa and Asia": "África y Asia",
  "North America": "Norteamérica",
  "Himalayan forests": "Bosques del Himalaya",
  "Forests worldwide": "Bosques de todo el mundo",
  "The Americas": "América",
  "North America and Europe": "Norteamérica y Europa",
  "Mexico": "México",
  "South America": "Sudamérica",
  "Worldwide wetlands": "Humedales de todo el mundo",
  "Australia": "Australia",
  "Central Asia": "Asia Central",

  "Electric Blue": "Azul eléctrico",
  "Crimson Red": "Rojo carmesí",
  "Emerald Green": "Verde esmeralda",
  "Royal Purple": "Morado real",
  "Solar Orange": "Naranja solar",
  "Pearl White": "Blanco perla",
  "Midnight Black": "Negro medianoche",
  "Rose Gold": "Oro rosa",
  "Arctic Cyan": "Cian ártico",
  "Volcanic Red": "Rojo volcánico",
  "Galaxy Violet": "Violeta galaxia",
  "Jungle Green": "Verde selva",
  "Sunny Yellow": "Amarillo soleado",
  "Neon Cyan": "Cian neón",
  "Hot Pink": "Rosa intenso",
  "Silver": "Plateado",
  "Lime": "Lima",
  "Copper": "Cobre",
  "Orange": "Naranja",
  "Electric Purple": "Morado eléctrico",
  "Ice Blue": "Azul hielo",
  "Blue": "Azul",
  "Red": "Rojo",
  "Purple": "Morado",
  "Green": "Verde",
  "Gold": "Dorado",
  "Pink": "Rosa",
  "Aqua": "Aguamarina",
  "Midnight": "Medianoche",
  "Pearl": "Perla",
  "Emerald": "Esmeralda",
  "Crimson": "Carmesí",

  "Vanguard Crown": "Corona vanguardia",
  "Samurai Helm": "Casco samurái",
  "Dragon Helm": "Casco de dragón",
  "Explorer Dome": "Cúpula exploradora",
  "Knight Visor": "Visor de caballero",
  "Cat Ear Helm": "Casco con orejas de gato",
  "Gundam Crest": "Cresta mecha",
  "Shogun Kabuto": "Kabuto shogun",
  "Falcon Helm": "Casco de halcón",
  "Astronaut Bubble": "Burbuja de astronauta",
  "Dino Helm": "Casco dinosaurio",
  "Lion Mane Helm": "Casco melena de león",
  "Ninja Hood": "Capucha ninja",
  "Crystal Crown": "Corona de cristal",
  "Rescue Helmet": "Casco de rescate",

  "Photon Visor": "Visor de fotones",
  "Twin Emerald Eyes": "Ojos esmeralda dobles",
  "Cyclops Lens": "Lente cíclope",
  "Star Eyes": "Ojos de estrella",
  "Scanner Array": "Conjunto de escáneres",
  "Friendly Pixels": "Píxeles amistosos",
  "Anime Eyes": "Ojos anime",
  "Laser Eyes": "Ojos láser",
  "Night Vision": "Visión nocturna",
  "Rainbow Optics": "Óptica arcoíris",
  "Hologram Face": "Rostro holográfico",
  "Six Sensor Array": "Seis sensores",

  "Star Reactor": "Reactor estelar",
  "Guardian Core": "Núcleo guardián",
  "Dragon Chest": "Pecho de dragón",
  "Stealth Frame": "Armazón sigiloso",
  "Rescue Armor": "Armadura de rescate",
  "Crystal Reactor": "Reactor de cristal",
  "Mecha Samurai": "Samurái mecha",
  "Heavy Titan": "Titán pesado",
  "Speed Frame": "Armazón veloz",
  "Aqua Armor": "Armadura acuática",
  "Space Knight": "Caballero espacial",
  "Dinosaur Core": "Núcleo dinosaurio",
  "Solar Guardian": "Guardián solar",
  "Construction Frame": "Armazón constructor",

  "Guardian Arms": "Brazos guardianes",
  "Photon Blades": "Espadas de fotones",
  "Giant Hands": "Manos gigantes",
  "Tool Arms": "Brazos herramienta",
  "Shield Arms": "Brazos escudo",
  "Rocket Fists": "Puños cohete",
  "Drill Arms": "Brazos taladro",
  "Claw Hands": "Manos garra",
  "Magnet Hands": "Manos imán",
  "Rescue Grippers": "Pinzas de rescate",
  "Energy Cannons": "Cañones de energía",
  "Painter Arms": "Brazos pintores",

  "Vernier Legs": "Piernas propulsoras",
  "Tank Treads": "Orugas de tanque",
  "Hover Ring": "Anillo flotante",
  "Rocket Boots": "Botas cohete",
  "Spider Legs": "Patas de araña",
  "Speed Wheels": "Ruedas veloces",
  "Dino Legs": "Patas de dinosaurio",
  "Moon Boots": "Botas lunares",
  "Skates": "Patines",
  "Aqua Fins": "Aletas acuáticas",
  "Spring Legs": "Piernas de resorte",
  "Four-Wheel Drive": "Tracción en cuatro ruedas",

  "Wing Binders": "Alas articuladas",
  "Jetpack": "Mochila propulsora",
  "Pet Drone": "Dron mascota",
  "Rocket Rack": "Bastidor de cohetes",
  "Solar Wings": "Alas solares",
  "Bubble Pack": "Mochila burbuja",
  "Samurai Flags": "Banderas samurái",
  "Rescue Crane": "Grúa de rescate",
  "Satellite Dish": "Antena satelital",
  "Dino Tail Pack": "Mochila cola de dinosaurio",
  "Tool Workshop": "Taller portátil",
  "Parachute": "Paracaídas",

  "Bubble Blaster": "Lanzador de burbujas",
  "Animal Translator": "Traductor de animales",
  "Rescue Beam": "Rayo de rescate",
  "Rainbow Shield": "Escudo arcoíris",
  "Dinosaur Scanner": "Escáner de dinosaurios",
  "Time Slow Field": "Campo ralentizador",
  "Plant Grower": "Cultivador de plantas",
  "Weather Maker": "Creador de clima",
  "Super Magnet": "Súper imán",
  "Healing Light": "Luz sanadora",
  "Portal Generator": "Generador de portales",

  "Brave Guardian": "Guardián valiente",
  "Curious Explorer": "Explorador curioso",
  "Silly Inventor": "Inventor divertido",
  "Gentle Helper": "Ayudante amable",
  "Fast Adventurer": "Aventurero veloz",
  "Wise Captain": "Capitán sabio",
  "Loyal Sidekick": "Compañero leal",
  "Joke Master": "Maestro de bromas",
  "Quiet Scientist": "Científico tranquilo",
  "Bold Rescue Hero": "Héroe de rescate audaz",
  "Creative Artist": "Artista creativo",
  "Animal Friend": "Amigo de los animales",

  "Happy": "Feliz",
  "Excited": "Emocionado",
  "Curious": "Curioso",
  "Brave": "Valiente",
  "Silly": "Divertido",
  "Calm": "Tranquilo",
  "Sleepy": "Soñoliento",
  "Focused": "Concentrado",
  "Classic Beep": "Pitido clásico",
  "Hero Voice": "Voz de héroe",
  "Tiny Chirp": "Chirrido pequeño",
  "Deep Captain": "Capitán profundo",
  "Silly Squeak": "Chillido divertido",
  "Robot Whisper": "Susurro robot",
  "Musical Chime": "Campanilla musical",
  "Space Radio": "Radio espacial",

  "Scout Animal Forest": "Explorar el Bosque animal",
  "Wildlife Photographer": "Fotógrafo de fauna",
  "Scan Monster Lab": "Escanear el Laboratorio de monstruos",
  "Monster Habitat Keeper": "Cuidador de hábitats de monstruos",
  "Organize Memory Museum": "Organizar el Museo de recuerdos",
  "Charge the Workshop": "Cargar el taller",
  "Recommend a Story": "Recomendar un cuento",
  "Find a Hidden Part": "Encontrar una pieza escondida",
  "Dinosaur Fossil Hunter": "Cazador de fósiles de dinosaurio",
  "Pet Trainer": "Entrenador de mascotas",
  "Arcade Coach": "Entrenador de juegos",
  "Art Gallery Curator": "Curador de galería de arte",
  "Robot Home Decorator": "Decorador de la Casa Robot",
  "Rescue Pilot": "Piloto de rescate",
  "Weather Watcher": "Observador del clima",
  "Joke Broadcaster": "Locutor de bromas",
  "Night Guard": "Guardia nocturno",
  "Map Navigator": "Navegante del mapa",
  "Friendship Helper": "Ayudante de amistad",
  "Science Assistant": "Asistente científico",
  "Repair Engineer": "Ingeniero de reparación",
  "Space Explorer": "Explorador espacial",
  "Treasure Finder": "Buscador de tesoros",

  "Blob": "Masa",
  "Dragon": "Dragón",
  "Jungle Beast": "Bestia de la selva",
  "Stone Golem": "Gólem de piedra",
  "Spirit": "Espíritu",
  "Cosmic": "Cósmico",
  "Aquatic": "Acuático",
  "Candy": "Dulce",
  "Mecha": "Mecha",
  "Royal": "Real",
  "Volcano": "Volcán",
  "Ice Beast": "Bestia de hielo",
  "Alien": "Alienígena",
  "Lizard Alien": "Alienígena lagarto",
  "Dinosaur": "Dinosaurio",
  "Cloud": "Nube",
  "One eye": "Un ojo",
  "Two eyes": "Dos ojos",
  "Three eyes": "Tres ojos",
  "Four eyes": "Cuatro ojos",
  "Sleepy eyes": "Ojos soñolientos",
  "Robot visor": "Visor robot",
  "Fire eyes": "Ojos de fuego",
  "Galaxy eyes": "Ojos galaxia",
  "Friendly smile": "Sonrisa amistosa",
  "Fang smile": "Sonrisa con colmillos",
  "Big grin": "Gran sonrisa",
  "Tiny mouth": "Boca pequeña",
  "Beak": "Pico",
  "Robot speaker": "Altavoz robot",
  "Dragon snout": "Hocico de dragón",
  "No horns": "Sin cuernos",
  "Tiny horns": "Cuernos pequeños",
  "Crystal horns": "Cuernos de cristal",
  "Dragon horns": "Cuernos de dragón",
  "Antlers": "Astas",
  "Unicorn horn": "Cuerno de unicornio",
  "Mecha antenna": "Antena mecha",
  "Flame horns": "Cuernos de fuego",
  "No wings": "Sin alas",
  "Bat wings": "Alas de murciélago",
  "Dragon wings": "Alas de dragón",
  "Star wings": "Alas de estrella",
  "Butterfly wings": "Alas de mariposa",
  "Mecha wings": "Alas mecha",
  "Angel wings": "Alas de ángel",
  "Fire wings": "Alas de fuego",
  "Tiny arms": "Brazos pequeños",
  "Claw arms": "Brazos garra",
  "Four arms": "Cuatro brazos",
  "Tentacles": "Tentáculos",
  "Robot arms": "Brazos robot",
  "Wing arms": "Brazos ala",
  "Tiny feet": "Pies pequeños",
  "Dinosaur legs": "Patas de dinosaurio",
  "Hover base": "Base flotante",
  "Robot treads": "Orugas robot",
  "Mermaid tail": "Cola de sirena",
  "No tail": "Sin cola",
  "Dragon tail": "Cola de dragón",
  "Lion tail": "Cola de león",
  "Scorpion tail": "Cola de escorpión",
  "Fish tail": "Cola de pez",
  "Flame tail": "Cola de fuego",
  "Robot cable": "Cable robot",
  "Solid": "Sólido",
  "Spots": "Manchas",
  "Stripes": "Rayas",
  "Galaxy": "Galaxia",
  "Scales": "Escamas",
  "Candy swirl": "Remolino de dulce",
  "Lightning": "Relámpagos",
  "Stars": "Estrellas",
  "Camouflage": "Camuflaje",
  "Circuit lines": "Líneas de circuito",
  "Smooth": "Liso",
  "Furry": "Peludo",
  "Crystal": "Cristal",
  "Stone": "Piedra",
  "Slime": "Gelatinoso",
  "Metal": "Metal",
  "Lava": "Lava",
  "Bubble beam": "Rayo de burbujas",
  "Plant growth": "Crecimiento de plantas",
  "Moonlight": "Luz de luna",
  "Super jump": "Súper salto",
  "Friendly roar": "Rugido amistoso",
  "Fire breath": "Aliento de fuego",
  "Ice blast": "Explosión de hielo",
  "Teleport": "Teletransporte",
  "Healing sparkle": "Brillo sanador",
  "Thunder clap": "Trueno",
  "Invisibility": "Invisibilidad",
  "Shy": "Tímido",
  "Helpful": "Servicial",
  "Loyal": "Leal",
  "Mischievous": "Travieso",
  "Wise": "Sabio",
  "Playful": "Juguetón",
  "Crystal Cave": "Cueva de cristal",
  "Cloud Nest": "Nido de nubes",
  "Jungle Hut": "Cabaña de la selva",
  "Ocean Dome": "Cúpula oceánica",
  "Candy Castle": "Castillo de dulces",
  "Moon Base": "Base lunar",
  "Volcano Fort": "Fuerte volcánico",
  "Ice Palace": "Palacio de hielo",
  "Mecha Garage": "Garaje mecha",
  "Star Garden": "Jardín de estrellas",
  "Bounce": "Rebotar",
  "Spin": "Girar",
  "Roar": "Rugir",
  "Fly": "Volar",
  "Dance": "Bailar",
  "Sleep": "Dormir",

  "Robot Dog": "Perro robot",
  "Robot Cat": "Gato robot",
  "Mini Dinosaur": "Mini dinosaurio",
  "Tiny Dragon": "Dragón pequeño",
  "Penguin Bot": "Pingüino robot",
  "Fox Bot": "Zorro robot",
  "Owl Scout": "Búho explorador",
  "Space Orb": "Orbe espacial",
  "Explorer Scarf": "Bufanda exploradora",
  "Star Collar": "Collar de estrella",
  "Goggles": "Gafas protectoras",
  "Tiny Crown": "Corona pequeña",
  "Tool Pack": "Mochila de herramientas",
  "Gentle": "Amable",

  "Charging Dock": "Estación de carga",
  "Animal Photo Wall": "Muro de fotos de animales",
  "Trophy Shelf": "Estante de trofeos",
  "Mecha Banner": "Bandera mecha",
  "Monster Plush": "Peluche de monstruo",
  "Star Window": "Ventana estelar",
  "Dino Fossil Case": "Vitrina de fósiles",
  "Art Gallery": "Galería de arte",
  "Adventure Poster": "Póster de aventura",
  "Starry Space": "Espacio estrellado",
  "Gold Frame": "Marco dorado",
  "Explore. Build. Imagine.": "Explora. Construye. Imagina.",

  "Animal Clue": "Pista animal",
  "Pattern Power": "Poder de patrones",
  "Robot Memory": "Memoria robot",
  "Dino Dig": "Excavación dinosaurio",
  "Monster Maze": "Laberinto de monstruos",
  "Rocket Math": "Matemáticas cohete",

  "Star Starter": "Inicio estelar",
  "Robot Engineer": "Ingeniero robot",
  "Wildlife Explorer": "Explorador de fauna",
  "Monster Maker": "Creador de monstruos",
  "Pet Partner": "Compañero de mascotas",
  "Young Artist": "Joven artista",
  "Story Builder": "Creador de cuentos",
  "Fossil Hunter": "Cazador de fósiles",
};

export function optionLabel(value: string | undefined, language: Language): string {
  if (!value) return "";
  return language === "es-MX" ? es[value] ?? value : value;
}

export function hasSpanishOption(value: string): boolean {
  return Boolean(es[value]);
}
